import { mapActions, mapGetters } from "vuex";
import getUniqId from "@/helper/getUniqId";
import { PERMISSIONS } from "@/constants/constants";
const TableSettings = () => import("@/shared/TableSettings/TableSettings");
/**
You should add this template in your template component with additional key => example key = 'bonus-charge'
@example <table-settings
			      v-if="isTableSettingsDrawer"
			      updateSettingsSave="onSettingsSave(key)"
			      updateSettingsCancel="onSettingsCancel"
			      updateSettingsClose="onSettingsClose"
			      updateSettingsAll="onSettingsAll"
			      :settings="getSettings"
			    ></table-settings>
			 */
export default {
	components: { TableSettings },
	computed: {
		...mapGetters([ "settingsHeaders", "permissions", "settings" ]),
		headers() {
			if (this.permissions[PERMISSIONS.TOTAL_VALUE])
				return this.settingsHeaders;
			if (this.$options.name === "Fuel" || this.$options.name === "WorkOrders")
				return this.settingsHeaders.filter((item) => item.value !== "total");
			return this.settingsHeaders;
		},
		getSettings() {
			if (this.permissions[PERMISSIONS.TOTAL_VALUE]) return this.settings;
			if (this.$options.name === "Fuel" || this.$options.name === "WorkOrders")
				return this.settings.filter((item) => item.value !== "total");
			return this.settings;
		},
	},
	data: () => ({
		isTableSettingsDrawer: false,
		uniqId: null,
	}),
	methods: {
		...mapActions([ "doSettingsSave", "doSettingsAll", "doSettingsReset", "onResetSettingsState" ]),
		async onSettingsCancel() {
			this.onSettingsClose();
			await this.doSettingsReset();
		},
		onSettingsClose() {
			this.isTableSettingsDrawer = false;
		},
		async onSettingsSave(key) {
			await this.doSettingsSave(key);
			this.uniqId = getUniqId();
		},
		async onSettingsAll(value) {
			await this.doSettingsAll(value);
		},
		onSettingsOpen() {
			this.isTableSettingsDrawer = true;
		},
	},
	destroyed() {
		this.onResetSettingsState();
	},
};
